export * as Api from './api';
export var InitialTargetShareOption;
(function (InitialTargetShareOption) {
    InitialTargetShareOption["InitialTargetShares"] = "initialTargetShares";
    InitialTargetShareOption["InitialTargetInvestment"] = "initialTargetInvestment";
    InitialTargetShareOption["InitialTargetAllocationPercent"] = "initialTargetAllocationPercent";
    InitialTargetShareOption["InitialTargetInvestmentAndShares"] = "initialTargetInvestmentAndShares";
})(InitialTargetShareOption || (InitialTargetShareOption = {}));
//# sourceMappingURL=index.js.map